import { render, staticRenderFns } from "./BooleanToIcon.vue?vue&type=template&id=7312db60"
import script from "./BooleanToIcon.vue?vue&type=script&lang=js"
export * from "./BooleanToIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports